import React from 'react';
import { List, ListItem, ListItemIcon, ListItemText, ListItemSecondaryAction } from '@material-ui/core';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import AudiotrackIcon from '@material-ui/icons/Audiotrack';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import ImageIcon from '@material-ui/icons/Image';
import DescriptionIcon from '@material-ui/icons/Description';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { MEDIA_TYPE, normalizeMediaType } from '../../utils/openMedia';

const ICON_BY_TYPE = {
    [MEDIA_TYPE.VIDEO]: PlayCircleOutlineIcon,
    [MEDIA_TYPE.AUDIO]: AudiotrackIcon,
    [MEDIA_TYPE.PDF]: PictureAsPdfIcon,
    [MEDIA_TYPE.IMAGE]: ImageIcon
};

const MediaIcon = ({ type }) => {
    const Icon = ICON_BY_TYPE[normalizeMediaType(type)] || DescriptionIcon;

    return <Icon color="primary" />;
};

/**
 * Lista de mídias (de um capítulo ou de uma atividade extra).
 * `onClickMedia` recebe a mídia inteira; quem decide como abrir é o pai.
 */
const MediaList = ({ medias, onClickMedia, dense }) => (
    <List disablePadding dense={dense}>
        {medias.map(media => (
            <ListItem key={media.id} button divider onClick={() => onClickMedia(media)}>
                <ListItemIcon>
                    <MediaIcon type={media.type} />
                </ListItemIcon>
                <ListItemText primary={media.name} secondary={media.description} />
                <ListItemSecondaryAction style={{ pointerEvents: 'none' }}>
                    <ChevronRightIcon color="action" />
                </ListItemSecondaryAction>
            </ListItem>
        ))}
    </List>
);

export default MediaList;
